import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../common/Header/Header';
import Toast from '../common/Toast/Toast';
import { useAppState } from '../../contexts/appState';
import { LoginErrorPopup } from '../Popups';
import './Layout.css';
import ExitPopup from '../../pages/ExitPopup/ExitPopup';
import { useAuth } from '../../contexts/auth';
import { getContractTypeVal } from '../../lib/common';
import { sendCommunication } from '../../api';

export default function Layout() {
  const [appState] = useAppState();
  const [authState] = useAuth();
  const [isExitPopup, setIsExitPopup] = useState(false);
  const [localtimer, setlocalTimer] = useState('');
  const [backevent, setbackevent] = useState(false);
  const [clickedsomewhere, setClickedsomewhere] = useState(false);
  const contractType = getContractTypeVal('csportal');
  let timer = 'started';

  document.addEventListener(
    'click',
    (e) => {
      e.stopImmediatePropagation();
      if (e.target.id === 'headerback') {
        setbackevent(true);
      } else {
        setClickedsomewhere(true);
      }
    },
    false,
  );
  const handleTimer = () => {
    timer = setTimeout(() => {
      timer = undefined;
      setlocalTimer(undefined);
    }, 15000);
    setlocalTimer(timer);
  };

  useEffect(() => {
    if (!sessionStorage.getItem('exitpopupOpen') && appState?.faqchangeState) {
      setbackevent(false);
      setClickedsomewhere(false);
      if (['paid', 'free', 'expiredShort'].includes(contractType)) {
        handleTimer();
      }
    }
  }, [sessionStorage.getItem('exitpopupOpen'), contractType, appState?.faqchangeState]);

  const callSendCommunication = async () => {
    try {
      const params = {
        mobile: authState?.userDetails?.mobile || '',
        email_id: authState?.userDetails?.email || '',
      };
      await sendCommunication(params);
      sessionStorage.setItem('communicationSentFlag', 1);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (backevent && !clickedsomewhere) {
      if (localtimer) {
        clearTimeout(localtimer);
      } else if (localtimer === undefined) {
        document.body.style.overflow = 'hidden';
        setIsExitPopup(true);
        if (contractType && contractType !== 'free' && !sessionStorage.getItem('exitpopupOpen')) {
          callSendCommunication();
        }
        sessionStorage.setItem('exitpopupOpen', 1);
      }
    }
  }, [localtimer, backevent, clickedsomewhere]);

  return (
    <div className="App">
      <Header />
      <Outlet />
      {appState?.alertSnackbar?.message && <Toast toastMsgObj={appState?.alertSnackbar || {}} />}
      {appState?.loginPopup?.open &&
        ((appState?.loginPopup?.click && !appState?.sidResponse) || appState?.validatorPopup?.individual) && (
          <LoginErrorPopup
            desc={appState?.validatorPopup?.individual ? appState?.validatorPopup?.desc : appState?.loginPopup?.desc}
            login={appState?.validatorPopup?.individual ? appState?.validatorPopup?.login : appState.loginPopup.login}
            redirect={
              appState?.validatorPopup?.individual ? appState?.validatorPopup?.redirect : appState.loginPopup.redirect
            }
          />
        )}
      {authState?.sidResponse && isExitPopup && <ExitPopup handleClose={() => setIsExitPopup(false)} />}
    </div>
  );
}
